import React from "react";
import './App.css';
import background from "./assets/img.png";
import Header from "./components/header/header";
import GlobalStyles from "./globalStyles";
import Welcome from "./components/welcome/welcome";
import styled from "styled-components";
import RobotSection from "./components/robotSection/robotSection";
import CardSection from "./components/cardSection/cardSection";
import VideoSection from "./components/videoSection/videoSection";
import ImagesSection from "./components/imagesSection/imagesSection";
import CustomersSection from "./components/customersSection/customersSection";
import FormSection from "./components/formSection/formSection";
import Footer from "./components/footer/footer";
import {device} from "./styles/breakpoints";


const MainSection = styled.div`
  background-image: url(${background});
  background-repeat: no-repeat;
  background-size: 100% 100%;

`;

const StyledSections = styled.div`
  padding: 0 5vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  @media ${device.tablet} {
    padding: 0 10vw;
  }
  @media ${device.desktop} {
    padding: 0 20vw;
  }

`;

const App = () => (
  <>
    <GlobalStyles/>
    <MainSection>
      <Header/>
      <Welcome/>
    </MainSection>
    <StyledSections>
      <RobotSection/>
      <CardSection/>
      <VideoSection/>
      <ImagesSection/>
      <CustomersSection/>
      <FormSection/>
    </StyledSections>
    <Footer/>
  </>
);
export default App;
